import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex h-full w-full"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "m-auto" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "animate-spin h-10 w-10 text-white",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      class: "opacity-25",
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      "stroke-width": "4"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "opacity-75",
      fill: "currentColor",
      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col overflow-y-scroll"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "safe-area-top" }, null, -1)
const _hoisted_6 = { class: "mx-auto max-w-7xl px-6 lg:px-8 py-10" }
const _hoisted_7 = { class: "isolate mx-auto grid max-w-md grid-cols-1 gap-8 lg:mx-0 lg:max-w-none lg:grid-cols-3" }
const _hoisted_8 = { class: "flex items-center justify-between gap-x-4" }
const _hoisted_9 = ["id"]
const _hoisted_10 = {
  key: 0,
  class: "rounded-full bg-brand-lime px-2.5 py-1 text-xs font-semibold leading-5 text-brand-black"
}
const _hoisted_11 = { class: "mt-4 text-sm leading-6 text-gray-300" }
const _hoisted_12 = { class: "mt-2 flex items-baseline gap-x-1" }
const _hoisted_13 = { class: "text-4xl font-bold tracking-tight text-white" }
const _hoisted_14 = { class: "text-sm font-semibold leading-6 text-gray-300" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "my-auto pt-0.5" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Subscribe")
  ])
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  role: "list",
  class: "mt-8 space-y-1 text-sm leading-6 text-gray-300 xl:mt-10"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "border-b pb-1" }, "I'm not ready to subscribe yet", -1)
const _hoisted_20 = [
  _hoisted_19
]

import {onMounted, ref} from 'vue'
import {CheckIcon} from '@heroicons/vue/20/solid'
import {IonContent, IonPage, modalController} from "@ionic/vue";
import ApiService from "@/services/api/apiService";


export default /*#__PURE__*/_defineComponent({
  __name: 'StripeSubscriptionPage',
  setup(__props) {

const dismiss = async () => {
  await modalController.dismiss()
}

const loading = ref(true)
const tiers = ref([])


onMounted(async () => {
  const user = await ApiService.User().authUser()
  tiers.value = await ApiService.Subscription().getTiers()
  loading.value = false
})

const subscribe = async (tier:any) => {
  window.open(tier.url)
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { class: "h-full flex flex-col" }, {
        default: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
            : _createCommentVNode("", true),
          (!loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiers.value, (tier) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: tier.id,
                        class: _normalizeClass([tier.most_popular ? 'bg-white/5 ring-2 ring-brand-lime' : 'ring-1 ring-white/10', 'rounded-3xl p-8 xl:p-10'])
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("h3", {
                            id: tier.id,
                            class: "text-lg font-semibold leading-8 text-white"
                          }, _toDisplayString(tier.name), 9, _hoisted_9),
                          (tier.most_popular)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Most popular"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(tier.description), 1),
                        _createElementVNode("p", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(tier.price.value), 1),
                          _createElementVNode("span", _hoisted_14, _toDisplayString(tier.price.suffix), 1)
                        ]),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (subscribe(tier)),
                          class: _normalizeClass([[tier.most_popular ? 'bg-brand-lime text-brand-black shadow-sm hover:bg-brand-lime/40 focus-visible:outline-indigo-500' : 'bg-white/10 text-white hover:bg-white/20 focus-visible:outline-white', 'mt-6 block rounded-full py-2 px-3 text-center  leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2'], "mx-auto w-full flex rounded-full px-8 h-12 font-medium text-xl transition-all"])
                        }, _hoisted_17, 10, _hoisted_15),
                        _createElementVNode("ul", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tier.features, (feature) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: feature,
                              class: "flex gap-x-3"
                            }, [
                              _createVNode(_unref(CheckIcon), {
                                class: "h-6 w-5 flex-none text-white",
                                "aria-hidden": "true"
                              }),
                              _createTextVNode(" " + _toDisplayString(feature), 1)
                            ]))
                          }), 128))
                        ])
                      ], 2))
                    }), 128))
                  ]),
                  _createElementVNode("div", {
                    onClick: dismiss,
                    class: "py-5 text-brand-light-gray w-full text-center"
                  }, _hoisted_20)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})